import { AxiosRequestConfig } from "axios";
import ApiClient from "../../services/apiClient";

export const npiRoleHistory = (
  npiId: any,
  id: any,
  opts?: AxiosRequestConfig
) => ApiClient.get(`/npi/${npiId}/role/${id}/history`, opts);
